import * as React from 'react';
import { PortalFieldLabel } from 'components/FormControls';
import { IMeta } from 'models/common';
import renderIcon, { IconName } from 'helpers/renderIcon';
import { Tooltip } from 'components';
const classNames = require('classnames');

const TEXTAREA_USAGE = {
	portal: '',
	admin: 'portalAdminTextareaField',
};

interface IProps {
	usage?: 'portal' | 'admin';
	input?: React.InputHTMLAttributes<HTMLTextAreaElement>;
	label?: any;
	type?: string;
	rows?: number;
	meta?: IMeta;
	autoFocus?: any;
	readOnly?: boolean;
	isDisabled?: boolean;
	onChangeAction?: any;
	tooltipText?: string;
	tooltipPosition?: any;
	description?: string;
	information?: string;
	className?: string;
	iconName?: IconName;
	iconClassName?: string;
	maxLength?: number;
	iconAction?: () => void | undefined;
	customRef?: React.RefObject<HTMLTextAreaElement> | undefined;
	onBlurAction?: () => void | undefined;
	customIconSizeWidth?: number;
	customIconSizeHeight?: number;
	placeholder?: string;
	hideCounter?: boolean;

	t?: (key: string) => string;
}

export const BookingTextareaField = (props: IProps) => {
	const { iconName, iconClassName, iconAction, onBlurAction, customIconSizeWidth, customIconSizeHeight } = props;
	let informationContainer: JSX.Element = null;
	if (typeof props.information !== 'undefined' && props.information !== null) {
		informationContainer = <div className="informationBlock">{props.information}</div>;
	}
	const usage = props.usage ? TEXTAREA_USAGE[props.usage] : TEXTAREA_USAGE.portal;

	let description: string | string[] = props.description || '';
	let status = '';

	if (props.meta?.touched) {
		if (props.meta?.warning) {
			status = 'withWarning';
			description = props.meta.warning;
		}
		if (props.meta?.error) {
			status = 'withError';
			description = props.meta.error;
		}
	}

	if (props.maxLength) {
		const maxLength = Number(props.maxLength);
		const value = String(props.input?.value || '');
		if (value.length > maxLength) {
			// FIXME translate
			description = 'Validation_Field_TooLong';
			status = 'withError';
		} else if (value.length <= maxLength) {
			description = [description as string, props.hideCounter ? '' : value.length + '/' + maxLength];
		}
	}

	return (
		<div className={classNames('bookingFieldGroup BookingTextarea', usage, status, props.className)}>
			{informationContainer}
			<label className="inputHolder cursor-text-hover">
				<textarea
					{...props.input}
					rows={props.rows}
					className={classNames(
						'inputField',
						{ ['inputError']: props.meta.touched && props.meta.error },
						{ value: props.input?.value },
						{ hasIconRight: iconName },
					)}
					autoFocus={props.autoFocus}
					readOnly={props.readOnly}
					disabled={props.isDisabled}
					ref={props.customRef}
					onInput={(e: React.FormEvent<HTMLTextAreaElement>) => {
						// Limit character amount
						const target = e.target as HTMLTextAreaElement;
						if (target.value.length > Number(props.maxLength)) {
							target.value = target.value.substring(0, Number(props.maxLength));
							e.preventDefault();
						}
					}}
					onChange={(e) => {
						if (props.onChangeAction) {
							props.onChangeAction(e);
						}
						if (props.input && props.input.onChange) {
							props.input.onChange(e);
						}
					}}
					onBlur={onBlurAction}
					placeholder={props.placeholder}
				/>
				{iconName
					? renderIcon(iconName, customIconSizeWidth || 22, customIconSizeHeight || 22, iconClassName, iconAction)
					: null}
				<PortalFieldLabel name={props.input.name} text={props.label} tag="div" />
				{props.tooltipText && props.tooltipText.length > 0 ? (
					<Tooltip position={props.tooltipPosition} message={props.tooltipText}>
						<a href="#" onClick={(e) => e.preventDefault()}>
							<img src={require('containers/Html/icons/tooltip-icon.png')} />
						</a>
					</Tooltip>
				) : null}
			</label>
			{description ? (
				<span className={'note' + (Array.isArray(description) ? ' split' : '')}>
					{Array.isArray(description) ? description.map((d, i) => <span key={i}>{d}</span>) : description}
				</span>
			) : null}
		</div>
	);
};
